import { savingsOverview } from './overview-config/AT';
import { savingsSettingsDetails } from './settings-config/AT';

export const savings = {
    settingsDetails: savingsSettingsDetails,
    overview: savingsOverview,
};
